/* @flow */

import type { JSON } from 'common/types';

export default function literal<V>(value: V): JSON => V {
  return _json => value;
}
